import type { AiUsageSource } from "./aiUsageSources";

const CONNECTOR_USAGE_SOURCES = [
  "workflow_run",
  "workflow_builder",
  "personal_chat",
  "autofix",
  "autotune",
  "step_test",
  "connection_test",
  "audit_log_delivery",
  "git_sync",
  "other",
] as const;

export type ConnectorUsageSource = (typeof CONNECTOR_USAGE_SOURCES)[number];

export const SPEND_LIMIT_USAGE_SOURCES = [
  "workflow_builder",
  "workflow_run",
  "personal_chat",
  "autofix",
  "autotune",
] as const satisfies readonly ConnectorUsageSource[];

export type SpendLimitUsageSource = (typeof SPEND_LIMIT_USAGE_SOURCES)[number];

const spendLimitUsageSources = new Set<string>(SPEND_LIMIT_USAGE_SOURCES);

export function isSpendLimitUsageSource(
  source: string
): source is SpendLimitUsageSource {
  return spendLimitUsageSources.has(source);
}

const CONNECTOR_USAGE_SOURCE_LABELS: Record<ConnectorUsageSource, string> = {
  workflow_run: "Workflow run",
  workflow_builder: "Workflow builder",
  personal_chat: "Personal chat",
  autofix: "Autofix",
  autotune: "Autotune",
  step_test: "Step tests",
  connection_test: "Connection tests",
  audit_log_delivery: "Audit log delivery",
  git_sync: "Git sync",
  other: "Other",
};

const SOURCE_BY_PURPOSE: Record<string, ConnectorUsageSource> = {
  step: "workflow_run",
  scheduled_step: "workflow_run",
  ai_execute: "workflow_builder",
  step_test: "step_test",
  step_test_capture: "step_test",
  connection_test: "connection_test",
  audit_log_destination: "audit_log_delivery",
  git_sync: "git_sync",
};

export function connectorUsageSourceForPurpose(
  purpose: string
): ConnectorUsageSource {
  return SOURCE_BY_PURPOSE[purpose] ?? "other";
}

export function connectorUsageSourceForAiUsage(
  source: AiUsageSource
): ConnectorUsageSource {
  return isSpendLimitUsageSource(source) ? source : "other";
}

export function connectorUsageSourceLabel(
  source: string | null | undefined
): string {
  return (
    CONNECTOR_USAGE_SOURCE_LABELS[source as ConnectorUsageSource] ?? "Other"
  );
}
